import { Localized } from "@fluent/react"
import { Alert, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material"
import { useState } from "react";
import { SaveButton } from "../../../../app/components/SaveButton";
import { CancelButton } from "../../../../app/components/CancelButton";
import { showError, showSuccess } from "../../../notifications/notificationsSlice";
import { useAppDispatch } from "../../../../app/hooks";
import { TeamMemberRoleMenuField } from "../../../documents/components/teamMembers/TeamMemberRoleMenuField";
import { DocumentTeamMemberRole } from "../../../documents/components/teamMemberApi";
import { CompanyRoleResponsibility, overrideCompanyRoleResponsibility } from "./companyRoleReponsibilitiesApi";

interface OverrideSystemRoleResponsibilityDialogProps {
    roleResponsibility?: CompanyRoleResponsibility;
    onSaveSuccess: (roleResponsibility: CompanyRoleResponsibility) => void;
    onCancel: () => void;
}

export const OverrideSystemRoleReponsibilitiesDialog: React.FC<OverrideSystemRoleResponsibilityDialogProps> = ({ roleResponsibility, onSaveSuccess, onCancel }) => {
    const dispatch = useAppDispatch();
    const [roleCode, setRoleCode] = useState<DocumentTeamMemberRole>(roleResponsibility?.roleCode ?? 'C');
    const [responsibilityPl, setResponsibilityPl] = useState<string>(roleResponsibility?.responsibilityPl ?? "");
    const [responsibilityEn, setResponsibilityEn] = useState<string>(roleResponsibility?.responsibilityEn ?? "");

    const [serverError, setServerError] = useState("");
    const [saving, setSaving] = useState<boolean>(false);

    const handleRoleCodeChange = (event) => setRoleCode(event.target.value);
    const handleResponsibilityPlChange = (event) => setResponsibilityPl(event.target.value);
    const handleResponsibilityEnChange = (event) => setResponsibilityEn(event.target.value);

    const handleConfirm = async () => {
        try {
            if (roleCode && responsibilityPl && responsibilityEn) {
                const result = await dispatch(overrideCompanyRoleResponsibility({
                    roleResponsibility: {
                        roleCode,
                        responsibilityPl,
                        responsibilityEn,
                        isSystem: false
                    }
                }))
                if (overrideCompanyRoleResponsibility.fulfilled.match(result)) {
                    dispatch(showSuccess("saved"))
                    onSaveSuccess(result.payload);
                } else {
                    let errorMsg = "error"
                    if (result.payload && result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title

                        }
                    }
                    setServerError(errorMsg)
                }
            }
        }
        catch (error) {
            dispatch(showError("error"));
        }
        finally {
            setSaving(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="role-responsibility-edit">
                    <span>_edit</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2} padding={2}>
                    <TeamMemberRoleMenuField
                        value={roleCode}
                        onChange={handleRoleCodeChange}
                    />
                    <TextField
                        fullWidth
                        value={responsibilityPl}
                        minRows={4}
                        multiline
                        onChange={handleResponsibilityPlChange}
                        label={<Localized id="role-responsibility-pl">_Odpowiedzialność PL</Localized>}
                    />
                    <TextField
                        fullWidth
                        value={responsibilityEn}
                        minRows={4}
                        multiline
                        onChange={handleResponsibilityEnChange}
                        label={<Localized id="role-responsibility-en">_Odpowiedzialność EN</Localized>}
                    />
                </Stack>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={onCancel} />
            </DialogActions>
        </>
    )
}